import { render } from "./TableView.vue?vue&type=template&id=728213f4&scoped=true&ts=true"
import script from "./TableView.vue?vue&type=script&lang=ts"
export * from "./TableView.vue?vue&type=script&lang=ts"

import "./TableView.vue?vue&type=style&index=0&id=728213f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728213f4"]])

export default __exports__